import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& > * + *': {
      textAlign: 'center',
      marginTop: theme.spacing(2),
    },
  },
}));
